import React, { Component } from 'react';
import { FormGroup, FormControl, Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from './Contents/Contribution';
import { ContributionServices } from '../../constants';
import { getWorkTypeNameById } from '../../utils';
import Select from '../Select';

export default class Contribution extends Component {
  options = () => ({
    other: this.props.other,
    field1: this.props.field1,
    field2: this.props.field2,
    contributor: this.props.contributor,
  });

  handleContent(e, field) {
    const options = this.options();

    if (field === 'field1') {
      if (e.target.value === 'other') {
        options.other = true;
      } else if (e.target.value !== '') {
        options.other = false;
      }
      options.field1 = e.target.value;
    } else if (field === 'contributor') {
      options.contributor = e.target.value;
    }

    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  handleOtherContent(e) {
    const options = this.options();

    options.field2 = e.target.value;
    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  getContributions() {
    const { fields, workTypes } = this.props;
    const typeName = getWorkTypeNameById(fields.type, workTypes);

    return ContributionServices[typeName];
  }

  render() {
    const { members } = this.props;
    const contributions = this.getContributions();

    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <p className="question">
              Which collaborator is the Contributor (non-owner) to this work?
            </p>
            <FormGroup className="answer">
              <Select
                className="form-control"
                value={this.props.contributor}
                onChange={(e) => this.handleContent(e, 'contributor')}
              >
                <option value="">Please select</option>
                {members.map((member, i) => {
                  if (member.user_info) {
                    let userName = member.user_info.name;
                    if (member.user_info.use_company_name) {
                      userName =
                        userName + ' (' + member.user_info.company_name + ')';
                    }
                    return (
                      <option key={i} value={member.user}>
                        {userName}
                      </option>
                    );
                  } else {
                    return null;
                  }
                })}
              </Select>
            </FormGroup>
            <p className="question">
              What was this Contributor's contribution to the work?
            </p>
            <FormGroup className="answer">
              <Select
                className="form-control"
                value={this.props.field1}
                onChange={(e) => this.handleContent(e, 'field1')}
              >
                <option value="">Please select</option>
                {contributions.map((contribution, i) => (
                  <option key={i}>{contribution}</option>
                ))}
                <option value="other">other</option>
              </Select>
            </FormGroup>
            {this.props.other ? (
              <FormGroup className="answer">
                <FormControl
                  type="text"
                  placeholder="Please type text here"
                  value={this.props.field2}
                  onChange={(e) => this.handleOtherContent(e)}
                />
              </FormGroup>
            ) : null}
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  The "contribution" is a description of the type of work that
                  will be done (e.g. production services, graphic design,
                  editing services). Defining this clears up any confusion about
                  what work is considered to have been done on a "work for hire"
                  basis.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/Contribution.jsx